// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"9f0618c285b3a49e67e0","245":"01905898bfc00d6830a9","452":"eec6f4494bd8da0b027a","453":"29f6ae0815c563877c1a"}[chunkId] + ".js";
};